var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('application-layout',[_c('v-main',[_c('v-container',{staticClass:"blacklist-index-container"},[_c('h1',[_vm._v("Do Not Rent List")]),_c('blacklist-create',{staticClass:"my-4"}),_c('blacklist-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }